import React, { useState, useEffect, useContext } from 'react'
import { Styles } from './styles'
import Table from "components/Table/Table";
import loyaltyAffiliationAPI from 'apis/loyaltyaffiliation/loyaltyaffiliation';
import Context from 'context/context';
import searchIcon from "assets/img/Search_Icon.png";
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


// matrerial ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

//Helpers
import useDebounce from "helpers/useDebounce";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import {dateFormat} from "helpers/dataFormat"
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";
// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: 20,
                background: "#ededed",
            },
        },
    },
})(TextField);



function LoyaltyAffiliation() {
    const classes = Styles()
    const { state, dispatch } = useContext(Context)
    const { getLoyaltyAffiliation, search,Export } = loyaltyAffiliationAPI()
    const [searchValue, setSearchValue] = useState("")
    const [offset, setOffset] = useState(1)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [count, setCount] = useState(0)
    const searchBounceValues = useDebounce(searchValue);
    const [exportData, setExportData] = useState([]);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        dispatch({
            type: "SET_PATHNAME",
            payload: ["HOME", "ADMIN", "Affiliated Shipto Details"],
        });
    }, []);

    useEffect(() => {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch()
        } else {
            handleGet()
        }
    }, [offset, searchBounceValues])

    async function handleGet() {
        try {
            setLoading(true)
            let values = {
                offset: (offset - 1) * 10,
                limit: 10,
            }
            let res = await getLoyaltyAffiliation(values)
            if (res) {
                setData(res.data)
                setCount(res.count)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            throw error
        }
    }

    async function handleSearch() {
        try {
            setLoading(true)
            let values = {
                searchValue,
                offset: (offset - 1) * 10,
                limit: 10,
            }
            let res = await search(values)
            if (res) {
                setData(res.data)
                setCount(res.count)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            throw error
        }
    }

    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleExport = async () => {
        // let values = {};
        // let values = {};
        if (searchValue) {
          values = { ...values, searchValue };
        }
        // setLoading(true)
        let values;
        values = {
            searchValue,
    
            
        };
    
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await Export(values);
        console.log(res,"ragav")
        if (res && res.data) {
            // setIsLoading(false);
            setExportData(res.data.map((d) => {
                return {
                  ...d,
                
                    is_active: d.is_active.toString()
               
    
                };
                
              })); 
            dispatch({ type: "SET_LOADING", payload: false });
           
            if (res.data.length === 0) {
              toast.success(t("No Data Found"), { toastId: "no-report-date" });
              return false;
            }
           
            return true;
          }
        }


    return (
        <>
            <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
                <Grid>
                    <CssTextField
                        id="enterPassword"
                        placeholder={t("Search for Member ID or Billto or Customer Account Number")}
                        onKeyDown={blockInvalidChar}
                        type={"number"}
                          onWheel={(e) => e.target.blur()}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue("");
                                                setOffset(1);
                                                // getRedemptionDetails();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            e.target.value.replace(/\s+/g, "").length == 0
                                ? setSearchValue("")
                                : setSearchValue(e.target.value);
                            if (e.target.value.length == 0) {
                                handleGet()
                            }
                        }}
                        onClick={() => {
                            setOffset(1);
                        }}
                    />
                </Grid>
                <CSVLink
            id="csv"
            data={exportData
               }
             headers={exportHeaders}
         filename={
              `Loyalty-Affiliation` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
            </Grid>

            <div style={{ marginTop: 20 }}>
                {!loading ? <Table
                    headings={[
                        "Member ID",
                        "Billto",
                        "Customer Account Number",
                        "Loyalty Start Date",
                        "Loyalty End Date",
                        "Status",
                    ]}
                    data={data &&
                        data.length > 0 &&
                        data.map((p) => [
                            [
                                <span
                                    className={classes.tableSpan}
                                >
                                    {p?.loyalty_id}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                >
                                    {p?.customer_billto_account_number}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                >
                                    {p?.customer_account_number}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                >
                                    {dateFormat(p?.loyalty_start_date, i18n.language)}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                >
                                    {p?.loyalty_end_date ? dateFormat(p?.loyalty_end_date, i18n.language) : '--'}
                                </span>
                            ],
                            [
                                <span
                                    className={classes.tableSpan}
                                >
                                    {p?.is_active ?
                                        [<CheckCircleIcon style={{ color: 'green' }} />] :
                                        [<HighlightOffIcon style={{ color: 'red' }} />]
                                    }
                                </span>
                            ],
                        ])}
                    offset={offset}
                    count={
                        (count / 10) % 1 == 0
                            ? Math.floor(count / 10)
                            : Math.floor(count / 10 + 1)
                    }
                    handlePagination={handlePagination}
                /> :
                    <div style={{ height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h2>{t('Loading...')}</h2>
                    </div>}
            </div>
        </>
    )
}

export default LoyaltyAffiliation